import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { msg } from '@lingui/core/macro';
import { currencyField } from './common/expenditureFields';
import { incidentIdField } from './common/sharedFields';

export const antiBriberyAndCorruptionIncidentsMetadata = {
  displayName: msg({
    message: 'Bribery and corruption',
    context: 'Activity data schema name for bribery and corruption incidents',
  }),
  fields: {
    ...coreFields,
    conviction_date: {
      displayName: msg({
        message: 'Conviction date',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          'The date when a conviction was issued in an anti-bribery or corruption incident.',
      }),
    },
    currency: currencyField,
    currency_quantity: {
      displayName: msg({
        message: 'Anti-bribery and corruption monetary remediation spend',
        context: 'The display name for a metric',
      }),
      externalDescription: msg({
        message:
          'The monetary amount spent on remediation for anti-bribery and corruption incidents.',
      }),
    },
    has_conviction: {
      displayName: msg({
        message: 'Has conviction',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          'Whether the incident resulted in a legal conviction for bribery or corruption.',
      }),
    },
    incident_id: incidentIdField,
    was_own_workers_dismissed: {
      displayName: msg({
        message: 'Own workers dismissed',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          'Whether any employees were dismissed as a result of the anti-bribery or corruption incident.',
      }),
    },
    was_related_to_contracts_that_were_negatively_affected: {
      displayName: msg({
        message: 'Is related to negatively affected contracts',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          'Whether the anti-bribery or corruption incident was related to contracts that were terminated or not renewed.',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
